<template>
    <div>

        <table class="table bg-white">
            <thead>
                <tr>
                    <th width="25%">Id</th>
                    <th width="25%">{{ exibir_nome ? 'Nome' : 'Data' }}</th>
                    <th width="25%" class="text-right">Valor</th>
                    <th width="25%" class="text-right">Saldo</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(adiantamento, iax) in lista_exibicao">
                    <tr :key="'A' + iax" :class="!adiantamento.saldo_adiantamento 
                        ? ( !adiantamento.fl_ativo ? 'table-warning' : 'table-secondary' ) : ''">
                        <td>
                            <a href="#" @click.prevent="adiantamento.selecionado = !adiantamento.selecionado" class="card-link mr-2">
                                <i class="fa fa-plus-square-o" v-if="!adiantamento.selecionado"></i>
                                <i class="fa fa-minus-square-o" v-else></i>
                            </a>
                            <a href="#" @click.prevent="abrir_pagamento(adiantamento.id_pagamento_atendimento)" class="card-link">
                                #{{ adiantamento.id_pagamento_atendimento }}
                            </a>
                            <span class="badge badge-light ml-1" v-if="adiantamento.unidade_operacao">
                                {{ adiantamento.unidade_operacao.st_sigla }}
                            </span>
                        </td>
                        <td>
                            <div v-if="exibir_nome">
                                {{ adiantamento.nome_paciente }}
                            </div>
                            {{ $util.getFormatDate(adiantamento.dt_data) }}
                        </td>
                        <td class="text-right">
                            {{ $util.formatMoeda(adiantamento.dc_valor_adiantado) }}
                        </td>
                        <td class="text-right">
                            {{ $util.formatMoeda(adiantamento.saldo_adiantamento) }}
                            <a href="#" @click.prevent="toggle_adiantamento(adiantamento)" class="card-link" title="Adiantamento em aberto." data-toggle="tooltip" data-placement="left" v-if="adiantamento.saldo_adiantamento > 0">
                                <i class="fas fa-door-open fa-fw ml-2"></i>
                            </a>
                            <a href="#" @click.prevent="toggle_adiantamento(adiantamento)" class="card-link" title="Adiantamento encerrado." data-toggle="tooltip" data-placement="left" v-else>
                                <i class="fas fa-door-closed fa-fw ml-2"></i>
                            </a>
                        </td>
                    </tr>

                    <template v-if="adiantamento.selecionado">
                        <tr :key="'C' + iax" class="table-info">
                            <td colspan="4">Composição</td>
                        </tr>
                        <tr :key="'CI' + iax" class="table-secondary">
                            <td colspan="4">
                                <table class="table table-sm">
                                    <tr v-for="(itp, itx) in adiantamento.item_pagamento_atendimentos" :key="itx">
                                        <td width="40%">{{ itp.forma_pagamento.search }}</td>
                                        <td width="35%">
                                            <span v-if="itp.bandeira_cartao">
                                                {{ itp.bandeira_cartao.search }}
                                                <div class="small">
                                                    {{ itp.st_autorizacao }}
                                                </div>
                                            </span>
                                        </td>
                                        <td width="25%" class="text-right">
                                            {{ $util.formatMoeda(itp.dc_valor) }}
                                            <i class="fas fa-plus-circle fa-fw text-success ml-2"></i>
                                        </td>
                                    </tr>
                                </table>
                                
                                <pre v-if="false">{{ itp }}</pre>
                            </td>
                        </tr>
                    
                        <template v-if="adiantamento.adiantamento_usos.length">
                            <tr :key="'U' + iax" class="table-info">
                                <td colspan="4">Uso</td>
                            </tr>
                            <tr :key="'UI' + iax" class="table-secondary">
                                <td colspan="4">
                                    <table class="table">
                                        <tr v-for="(itp, itx) in adiantamento.adiantamento_usos" :key="itx">
                                            <td width="25%">
                                                #{{ itp.pagamento_atendimento.id_atendimento }}
                                            </td>
                                            <td width="50%">
                                                {{ $util.getFormatDate(itp.pagamento_atendimento.dt_data) }}
                                                <span v-if="origem == 'E' && itp.pagamento_atendimento.atendimento && itp.pagamento_atendimento.atendimento.paciente">
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                    {{ itp.pagamento_atendimento.atendimento.paciente.st_nome }}
                                                </span>
                                            </td>
                                            <td width="25%" class="text-right">
                                                {{ $util.formatMoeda(itp.dc_valor) }}
                                                <i class="fas fa-minus-circle fa-fw text-danger ml-2"></i>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </template>

                        <template v-if="adiantamento.abatimentos && adiantamento.abatimentos.length">
                            <tr :key="'UA' + iax" class="table-info">
                                <td colspan="4">Abatimentos</td>
                            </tr>
                            <tr :key="'UAI' + iax" class="table-secondary">
                                <td colspan="4">
                                    <table class="table">
                                        <tr v-for="(abt, itx) in adiantamento.abatimentos" :key="itx">
                                            <td width="25%">
                                                <a href="#" @click.prevent="remover_abatimento(abt)" class="card-link mr-3">
                                                    <i class="fa-solid fa-trash-can text-danger"></i>
                                                </a>
                                                #{{ abt.id_pagamento_atendimento_abatimento }}
                                            </td>
                                            <td width="50%">
                                                {{ $util.getFormatDate(abt.created_at) }}
                                                <div class="small text-muted" v-if="abt.usuario && abt.usuario.pessoa">
                                                    Por: {{ abt.usuario.pessoa.st_nome }}
                                                </div>
                                                <div class="small text-muted" v-if="abt.st_observacoes">
                                                    {{ abt.st_observacoes }}
                                                </div>
                                            </td>
                                            <td width="25%" class="text-right">
                                                {{ $util.formatMoeda(abt.dc_valor) }}
                                                <i class="fas fa-minus-circle fa-fw text-danger ml-2"></i>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </template>
                    </template>
                </template>
            </tbody>
            <tfoot>
                <tr>
                    <th width="50%" colspan="2">Total</th>
                    <th width="25%" class="text-right">
                        {{ $util.formatMoeda(total_valor_adiantamento) }} 
                    </th>
                    <th width="25%" class="text-right">
                        {{ $util.formatMoeda(total_saldo_adiantamento) }}
                    </th>
                </tr>
            </tfoot>
        </table>

        <!-- Toggle Adiantamento -->
        <div class="modal fade" id="toggleAdiantamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="ad_para_fechar">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Adiantamento
                            <span class="badge badge-secondary">
                                #{{ ad_para_fechar.id_pagamento_atendimento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-primary">
                            <div v-if="exibir_nome" class="lead">
                                {{ ad_para_fechar.nome_paciente }}
                            </div>
                            Saldo: {{ $util.formatMoeda(ad_para_fechar.saldo_adiantamento) }}
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    label="Observações"
                                    type="textarea"
                                    v-model="ad_para_fechar.st_observacoes" />
                            </div>
                        </div>

                        <template v-if="ad_para_fechar.fl_ativo">

                            <div class="row mt-3">
                                <div class="col col-12">
                                    <az-input
                                        type="button-group"
                                        :optionsList="[
                                            { id: 'T', search: 'Total' },
                                            { id: 'P', search: 'Parcial' },
                                        ]"
                                        v-model="ad_para_fechar.escopo" />
                                </div>
                            </div>

                            <div class="row" v-if="ad_para_fechar.escopo == 'P'">
                                <div class="col col-12">
                                    <az-input
                                        type="money"
                                        label="Valor de Abatimento"
                                        v-model="ad_para_fechar.escopo_valor" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_toggle_adiantamento(ad_para_fechar)"
                            :color="ad_para_fechar.fl_ativo ? 'danger' : 'success'">
                            {{ ad_para_fechar.fl_ativo ? 'Encerrar' : 'Reabrir' }}
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            ad_para_fechar: null, 
            novo: false, 
        };
    },

    components: { 
        AzInput,
        AzSubmit,
    },

    props: ['adiantamentos', 'search', 'exibir_nome', 'origem'],

    computed: { 

        lista_exibicao: function () { 
            if ( !this.adiantamentos )
                return [];

            let reg = this.$util.getregex(this.search);

            return this.adiantamentos.filter(item => { 
              return ( !this.search || reg.test(JSON.stringify(item)) )
            });
        },

        total_valor_adiantamento: function () {
            if ( !this.adiantamentos ) { 
                return 0;
            } 

            return this.lista_exibicao.reduce((total, carry) => { 
                return total + carry.dc_valor_adiantado
            }, 0);
        },

        total_saldo_adiantamento: function () { 
            if ( !this.adiantamentos ) { 
                return 0;
            } 

            return this.lista_exibicao.reduce((total, carry) => { 
                return total + carry.saldo_adiantamento;
            }, 0);
        },

    },

    methods: { 

        toggle_adiantamento (item) { 
            let info = _.cloneDeep(item);

            info.escopo = "T";
            info.escopo_valor = 0;

            this.ad_para_fechar = info;
            
            $('#toggleAdiantamentoModal').modal('show');
        },

        abrir_pagamento(id) { 
            this.novo = true;

            this.$nextTick(() => { 
                this.$refs.pag.abrir_pagamento(id);
            });
        },

    },
    
}
</script>